import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { dm_trang_thai_lead } from '../../../models/response/category/dm_trang_thai_lead';
import { eDmTrangThaiLeadActionTypeIds, IDmTrangThaiLeadActionTypes } from '../../action-types/crm-category/IDmTrangThaiLeadActionTypes';
import { actions } from '../../actions/actionsWrapper';

export function* dmTrangThaiLeadSaga(): any {
    yield takeLatest(eDmTrangThaiLeadActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eDmTrangThaiLeadActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eDmTrangThaiLeadActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IDmTrangThaiLeadActionTypes): any {
    const dm_coso_id: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.trangThaiLead.select_by_coso, dm_coso_id)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.dmTrangThaiLead.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.dmTrangThaiLead.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IDmTrangThaiLeadActionTypes): any {
    const payload: dm_trang_thai_lead = action.payload as dm_trang_thai_lead;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.crmCategoryWrapper.trangThaiLead.update, payload)
    } else {
        res = yield call(apiWrapper.crmCategoryWrapper.trangThaiLead.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.dmTrangThaiLead.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.dmTrangThaiLead.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IDmTrangThaiLeadActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.trangThaiLead.delete, payload)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.dmTrangThaiLead.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.crmCategoryWrapper.dmTrangThaiLead.DELETE_ERROR(res.message ?? "Error"))
    }
}
